@if (initialLoading()) {
  <ots-initial-loading />
}
<router-outlet />
